// NPC Customer Data for when human customers are unavailable

export interface NPCCustomer {
  id: string;
  name: string;
  characterId: string;
  personality: 'patient' | 'normal' | 'impatient';
  favoriteCategories: string[];
}

// Pool of NPC customers
export const NPC_CUSTOMERS: NPCCustomer[] = [
  {
    id: 'npc_emma',
    name: 'Emma (NPC)',
    characterId: 'girl_1',
    personality: 'patient',
    favoriteCategories: ['breakfast', 'snack'],
  },
  {
    id: 'npc_sarah',
    name: 'Sarah (NPC)',
    characterId: 'girl_2',
    personality: 'normal',
    favoriteCategories: ['lunch', 'dinner'],
  },
  {
    id: 'npc_margaret',
    name: 'Margaret (NPC)',
    characterId: 'girl_3',
    personality: 'impatient',
    favoriteCategories: ['breakfast', 'lunch'],
  },
  {
    id: 'npc_harold',
    name: 'Harold (NPC)',
    characterId: 'city_man_1',
    personality: 'patient',
    favoriteCategories: ['dinner', 'snack'],
  },
  {
    id: 'npc_robert',
    name: 'Robert (NPC)',
    characterId: 'city_man_2',
    personality: 'impatient',
    favoriteCategories: ['breakfast', 'lunch'],
  },
  {
    id: 'npc_james',
    name: 'James (NPC)',
    characterId: 'city_man_3',
    personality: 'normal',
    favoriteCategories: ['lunch', 'dinner'],
  },
];

// Character ID to sprite URL mapping
export const CHARACTER_SPRITES: Record<string, string> = {
  girl_1: '/images/characters/sprites/girl_1_idle.png',
  girl_2: '/images/characters/sprites/girl_2_idle.png',
  girl_3: '/images/characters/sprites/girl_3_idle.png',
  city_man_1: '/images/characters/sprites/city_man_1_idle.png',
  city_man_2: '/images/characters/sprites/city_man_2_idle.png',
  city_man_3: '/images/characters/sprites/city_man_3_idle.png',
  chibi_wizard: '/images/characters/sprites/chibi_wizard_idle.png',
  chibi_swordsman: '/images/characters/sprites/chibi_swordsman_idle.png',
  chibi_archer: '/images/characters/sprites/chibi_archer_idle.png',
};

export function getCharacterSprite(characterId: string | undefined): string {
  return CHARACTER_SPRITES[characterId || ''] || CHARACTER_SPRITES['girl_1'];
}

// Get a random NPC customer
export function getRandomNPC(): NPCCustomer {
  return NPC_CUSTOMERS[Math.floor(Math.random() * NPC_CUSTOMERS.length)];
}

// Get NPC by ID
export function getNPCById(id: string): NPCCustomer | undefined {
  return NPC_CUSTOMERS.find(npc => npc.id === id);
}
